import { useRef } from 'react'
import { BiFont } from 'react-icons/bi'
import {
    StyleDropdownWrapper, ToolbarButton,
    ColorPickerDropdown, ColorSwatchGrid, ColorSwatch,
    ColorPickerRow, ColorPickerInput, ColorPickerLabel,
    ColorIconWrapper, ColorBar
} from './FormattingStyles'

const PRESET_COLORS = [
    '#000000', '#ffffff', '#6b7280', '#d1d5db',
    '#ef4444', '#f97316', '#eab308', '#22c55e',
    '#3b82f6', '#8b5cf6', '#ec4899', '#14b8a6',
    '#b45309', '#065f46', '#1e40af', '#6d28d9',
]

export default function TextColorPicker({ isOpen, onToggle, currentColor, onColorChange, dropdownRef, mobile }) {
    const nativePickerRef = useRef(null)

    return (
        <StyleDropdownWrapper ref={dropdownRef}>
            <ToolbarButton
                $active={isOpen}
                onMouseDown={(e) => { e.preventDefault(); onToggle() }}
                title="Text color"
            >
                <ColorIconWrapper>
                    <BiFont size={14} />
                    <ColorBar $color={currentColor || '#000000'} />
                </ColorIconWrapper>
            </ToolbarButton>

            {isOpen && (
                <ColorPickerDropdown $mobile={mobile}>
                    <ColorSwatchGrid>
                        {PRESET_COLORS.map(color => (
                            <ColorSwatch
                                key={color}
                                $color={color}
                                $active={currentColor === color}
                                onMouseDown={(e) => {
                                    e.preventDefault()
                                    onColorChange(color)
                                }}
                                title={color}
                            />
                        ))}
                    </ColorSwatchGrid>
                    <ColorPickerRow>
                        <ColorPickerInput
                            type="color"
                            ref={nativePickerRef}
                            value={currentColor || '#000000'}
                            onChange={(e) => onColorChange(e.target.value)}
                            onMouseDown={(e) => e.stopPropagation()}
                            title="Custom color"
                        />
                        <ColorPickerLabel>Custom color</ColorPickerLabel>
                    </ColorPickerRow>
                </ColorPickerDropdown>
            )}
        </StyleDropdownWrapper>
    )
}
